import _ from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector as reduxFormValueSelector } from 'redux-form';

import { makeOptionsWithNull } from 'Common/FormHelper';
import { PRODUCTION_GRID_FORM_NAME } from 'Common/FormEnum';
import { ProductionGridFieldEnum as ProductionGridFields } from 'Common/FieldEnum';

const root = state =>
  _.get(state, 'ManageProductionState.manageProduction', {});

const formValueSelector = reduxFormValueSelector(PRODUCTION_GRID_FORM_NAME);

export const getSiteMenus = state => _.get(root(state), 'menus', []);

export const getSiteMenusOptions = createSelector(getSiteMenus, siteMenus => {
  if (siteMenus.length === 0) {
    return [];
  }

  return makeOptionsWithNull(siteMenus, {
    keyKey: 'CycleMenuId',
    valueKey: 'CycleMenuId',
    textKeys: ['CycleMenuDescription'],
  });
});

export const getFetchingMenus = state =>
  _.get(root(state), 'fetchingMenus', false);

export const getProdRecords = state => _.get(root(state), 'prodRecords', []);

export const getFetchingProdRecords = state =>
  _.get(root(state), 'fetchingProdRecords', false);

export const getStartDate = state =>
  formValueSelector(state, ProductionGridFields.StartDate);

export const getEndDate = state =>
  formValueSelector(state, ProductionGridFields.EndDate);

export const getCycleMenuId = state =>
  formValueSelector(state, ProductionGridFields.CycleMenuId);

export const getStatus = state =>
  formValueSelector(state, ProductionGridFields.Status);

export const getSiteId = state =>
  formValueSelector(state, ProductionGridFields.SiteId);

export const getError = state => _.get(root(state), 'error');

export const getCloseProdRecordSuccessful = state =>
  _.get(root(state), 'closeProdRecordSuccessful', false);

export const getReopenProdRecordSuccessful = state =>
  _.get(root(state), 'reopenProdRecordSuccessful', false);

export const getFetchingCloseProdRecord = state =>
  _.get(root(state), 'fetchingCloseProdRecord', false);

  export const getFetchingReopenProdRecord = state =>
  _.get(root(state), 'fetchingReopenProdRecord', false);



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/manageproduction/selectors.js